import Vue from 'vue'
import store from '../../store/index';
import moverHelper from '../../helpers/mover-helper';
export default {
  name: 'home',
  beforeRouteEnter: function (to, from, next) {
      let login = to.query.login || null
      let client_id = to.query.client_id || null
      let user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
      if(login && client_id){
        let res = moverHelper.login(client_id,login).then(res=>{
          if (res) {
            next("/pickup/get-state");
          } else {
            next(true)
          }
        })
      }
      else{
        if (user && !user.completed_process) {
          next("/pickup/get-state");
        }
        else if(user && user.completed_process){
          next(true)
        }
        else{
          next(true);
        }
      }
  },
  created () {
  },
  mounted () {
  },
  data () {
      return {
      }
  },
  methods: {
    next(){
        // let user = this.$store.getters.user;
        
        // if(!user || !user.token) {
        //     this.$router.push({ name: "client-login" });
        // }
        // else if (user && !user.completed_process) {
            this.$router.push({ name: "get-state" });
        // }
        // else if (user && user.completed_process) {
        //     this.$router.push('/thankyou');
        // } 
    },
  }
}


// WEBPACK FOOTER //
// ./src/pages/Home/home.script.js